{
  "primer": {
    "eyebrow": "Waktu solat dan Kiblat",
    "headline": "Rhemn memerlukan lokasi anda untuk waktu solat dan arah Kiblat.",
    "body": "Kami menggunakannya untuk waktu solat, arah Kiblat dan cuaca setempat anda — tiada yang lain.",
    "cta": "Teruskan",
    "skip": "Bukan sekarang",
    "skip_body": "Waktu solat dan arah Kiblat akan kekal dimatikan."
  }
}
